import paymentApi from '../utils/paymentApi';

export const CONTENT_TAXONOMY_SCOPES = Object.freeze({
  videoCases: 'video_case_category',
  assets: 'asset_type',
  templates: 'project_template_type',
});

function unwrapLaravel(response) {
  const payload = response?.data;
  if (Number(payload?.code) !== 200) {
    if (Number(payload?.code) === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    throw new Error(payload?.message || '分类配置加载失败');
  }
  return payload?.data || {};
}

export async function getContentTaxonomies(scope) {
  const data = unwrapLaravel(await paymentApi.get('/content-taxonomy/list', { params: { scope } }));
  return (Array.isArray(data.list) ? data.list : []).map(item => ({
    id: item.id,
    code: String(item.code || ''),
    name: String(item.name || item.code || ''),
    sort: Number(item.sort || 0),
  })).filter(item => item.code);
}
